// Pan-tilt type options — used in individual device forms (DeviceDetailsForm, DeviceDynamicFields)
export const panTiltTypeOptions = [
  { value: "JSys", label: "JSys" },
  { value: "JSysV2", label: "JSysV2" },
];

export interface ISKUDeviceData {
  name: string; // matches catalog subcomponent name (e.g. "Optical 1", "Ch4")
  models: string[];
}

export interface ISKUForm {
  skuNumber: string;
  configurationName: string;
  password?: string;
  hasRecordVideo?: boolean;
  defaultIp?: string;
  skuDataConfigurations: ISKUDeviceData[];
}

export const defaultSKUForm: ISKUForm = {
  skuNumber: "",
  configurationName: "",
  password: "",
  hasRecordVideo: true,
  defaultIp: "",
  skuDataConfigurations: [],
};

export const skuFormRules = {
  skuNumber: {
    required: true,
  },
  configurationName: {
    required: true,
  },
  skuDataConfigurations: {
    models: {
      required: true,
    },
    password: {
      minLength: 8,
    },
  },
};

export const modelLabelMap: Record<string, string> = {
  gasleak: "Leak",
  liquidleak: "Liquid Leak",
  firesmoke: "Fire/Smoke",
  hardhat: "Hard Hat",
  agg: "Gate Guard",
  tlm: "Tank Level",
};

// Static allowed models per subcomponent type — derived from SKU catalog component types.
// AGX and POE nodes have no model assignments (they are processing/power nodes).
export const ALLOWED_MODELS_BY_TYPE: Record<string, string[]> = {
  CH4: ["gasleak"],
  OPT: ["firesmoke", "hardhat", "liquidleak"],
  THM: ["firesmoke", "hardhat", "liquidleak"],
  LWOP: ["liquidleak"],
  VOC: ["gasleak"],
  AGX: [],
  POE: [],
};
